/**
 * Mode override for the live-aware docs block adapter (PRD-9a).
 *
 * The docs adapter (`useLiveDocsBlock`) decides between fixture and live
 * data based on the auth state. Some consumers — notably **guided demos'
 * simulation mode** ([Guided Demos PRD-G2](../../../../../../docs/internal/product/guided-demos.md))
 * — need to render docs blocks against fixture data even for a signed-in
 * reader so the simulation shell never talks to live workspace data.
 *
 * Wrap the affected subtree in `<LiveDocsBlockModeProvider mode="fixture">`
 * to force every live-aware docs block inside it to render its fixture.
 * The default (no provider, or `mode="auto"`) is the standard
 * anonymous-vs-signed-in selection.
 *
 * Kept as a tiny standalone module (separate from the adapter) so the
 * adapter and the override can be imported independently — and so the
 * simulation shell can re-export the provider without pulling in the
 * adapter's React Query dependency surface.
 */
import { createContext } from 'react';

export type LiveDocsBlockMode = 'auto' | 'fixture';

/**
 * `'auto'` (default) — hook reads `AuthContext` and picks fixture or live.
 * `'fixture'` — hook always returns the fixture, regardless of auth.
 */
export const LiveDocsBlockModeContext = createContext<LiveDocsBlockMode>('auto');
